export default "__VITE_ASSET__Ct$LLCVB__"